export default {
  REQUIRED: [v => !!v || 'Campo obligatorio'],
  REQUIRED_MULTIPLE: [v => !!v && !!v.length || "Campo obligatorio"],
  EMAIL: [v => !!v || 'Email obligatorio', v => /.+@.+\..+/.test(v) || 'E-mail inválido']
}
